import "./roadmap.styles.scss"

function Roadmap() {
  const data = [
    {
      date: "Q4 2021",
      title: "Alpha and Beta launch",
      text: [
        "Alpha MVP built ",
        "Alpha receives 1000+ sign-ups ",
        "Influencer partnerships reach 1m total following",
        "Blockchain beta launch ",
      ],
    },
    {
      date: "Q1 2022",
      title: "Initial fundraising round",
      text: [
        "Obtain seed investment to fund development",
        "Release full testnet build",
        "Scale community",
      ],
    },

    {
      date: "Q2 2022",
      title: "Mainnet release",
      text: [
        "Iterative Mainnet build",
        "Partnerships ",
        "Ongoing improvements",
      ],
    },
    {
      date: "Q3 2022 +",
      title: "Moving towards DAO",
      text: ["Product refinement", "Public token launch"],
    },
  ]

  return (
    <div className="roadmap">
      <h4 className="heading">Roadmap</h4>
      <div className="content">
        {data.map((datum, index) => {
          return (
            <div key={index} className="roadmap-item">
              <div>
                <h3>{datum.date}</h3>
              </div>
              <hr />
              <div>
                <h4>{datum.title}</h4>
                {datum.text.map((milestone, index) => {
                  return <h5 key={index}>{milestone}</h5>
                })}
                <h5></h5>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Roadmap
